import { render, staticRenderFns } from "./OrderFooter.vue?vue&type=template&id=64e5e467&scoped=true&"
import script from "./OrderFooter.vue?vue&type=script&lang=js&"
export * from "./OrderFooter.vue?vue&type=script&lang=js&"
import style0 from "./OrderFooter.vue?vue&type=style&index=0&id=64e5e467&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5e467",
  null
  
)

export default component.exports